module.exports = __webpack_public_path__ + "img/hengshui.50efade8.jpg";